(function($) {
    $(function() {
        //Get the accordion item according to its index (0 based)
		var $accordionItem = $('.is-accordion-submenu-item.current-menu-item');
		var $accordionParents = $accordionItem.parents(".sub-menu");
		//Set the aria attributes of the accordion item you want to appear
		$accordionParents.attr('aria-expanded', 'true');
		$accordionParents.attr('aria-selected', 'true');
		//Set the attributes of the content.
		$accordionParents.attr('aria-hidden', 'false');
		$accordionParents.css('display', 'flex');
		//This is essential as it lets foundation know that the item is active (to re-allow toggling)
		$accordionItem.trigger('click');
    });
} )( jQuery );